import * as ReactJsxRuntime from "react/jsx-runtime";

function stripInvalidRef(props) {
  if (!props || typeof props !== "object" || !("ref" in props)) return props;
  const ref = props.ref;
  const isValid =
    ref == null || typeof ref === "function" || typeof ref === "object";
  if (isValid) return props;
  const { ref: _ref, ...rest } = props;
  // eslint-disable-next-line no-console
  console.error("[offlico] Dropped invalid ref from jsx runtime", { ref });
  return rest;
}

export const Fragment = ReactJsxRuntime.Fragment;

export function jsx(type, props, key) {
  return ReactJsxRuntime.jsx(type, stripInvalidRef(props), key);
}

export function jsxs(type, props, key) {
  return ReactJsxRuntime.jsxs(type, stripInvalidRef(props), key);
}
